import { render, staticRenderFns } from "./RecordtableTypefaces.vue?vue&type=template&id=41e3031a&"
import script from "./RecordtableTypefaces.vue?vue&type=script&lang=js&"
export * from "./RecordtableTypefaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports